/*
 * If you want scroll based animations in project, include this file.
 * It contains set of pre-defined animations described by corporate style.
 *
 * See https://8wmedia.atlassian.net/wiki/spaces/WFE/pages/333972028/Animation+Principles
 */

import { TweenMax } from 'gsap/TweenMax';
import 'ScrollToPlugin';
import 'animation.gsap';
import detectMobile from '@/scripts/utils/detect-mobile';
import ScrollMagic from 'scrollmagic';
import controller from '../controller';

document.addEventListener('DOMContentLoaded', () => {
  const $elements = $('.content .editable').children()
    .add('.content .buttons')
    .add('.content .social')
    .add('.content .input-block');

  $elements.each((i, el) => {
    let tween;

    if (el.classList.contains('buttons') ||
      el.classList.contains('social') ||
      el.tagName === 'UL' ||
      el.tagName === 'OL') {
      tween = TweenMax.staggerFromTo(el.children, 0.5, {
        autoAlpha: 0,
        y: 45,
      }, {
        autoAlpha: 1,
        y: 0,
      }, 0.1);
    } else {
      tween = TweenMax.fromTo(el, 0.5, {
        autoAlpha: 0,
        y: 15,
      }, {
        autoAlpha: 1,
        y: 0,
      });
    }

    new ScrollMagic.Scene({
      reverse: false,
      triggerElement: el,
      triggerHook: 0.85,
    }).setTween(tween)
      .addTo(controller);
  });

  $('[data-animation="section"]').each((i, el) => {
    const tween = TweenMax.fromTo(el, 1, { autoAlpha: 0, y: 60 }, {
      autoAlpha: 1,
      y: 0,
      clearProps: 'all',
    });
    new ScrollMagic.Scene({
      duration: 0,
      reverse: false,
      triggerElement: el,
      triggerHook: 'onEnter',
    }).setTween(tween)
      .addTo(controller);
  });
  $('[data-animation="stagger-child"]').each((i, el) => {
    const tween = TweenMax.staggerFromTo($(el).children(), 1, { autoAlpha: 0, y: 100 }, {
      autoAlpha: 1,
      y: 0,
      clearProps: 'transform, opacity',
    }, 0.15);
    new ScrollMagic.Scene({
      duration: 0,
      reverse: false,
      triggerElement: el,
      triggerHook: 0.9,
    }).setTween(tween)
      .addTo(controller);
  });
  $('[data-animation="list"]').each((i, el) => {
    $(el.children).each((k, elem) => {
      const tween = TweenMax.fromTo(elem, 1, { autoAlpha: 0, y: 60 }, {
        autoAlpha: 1,
        y: 0,
        clearProps: 'transform, opacity',
      });
      new ScrollMagic.Scene({
        duration: 0,
        reverse: false,
        triggerElement: elem,
        triggerHook: 'onEnter',
      }).setTween(tween)
        .addTo(controller);
    });
  });
  $('[data-animation="two-halves-right"]').each((i, el) => {
    const tween = TweenMax.fromTo(el, 1, { x: '100%' }, { x: '0%', clearProps: 'all' });
    new ScrollMagic.Scene({
      duration: 0,
      reverse: false,
      triggerElement: el,
      triggerHook: 0.85,
    }).setTween(tween)
      .addTo(controller);
  });
  $('[data-animation="two-halves-left"]').each((i, el) => {
    const tween = TweenMax.fromTo(el, 1, { x: '-100%' }, { x: '0%', clearProps: 'all' });
    new ScrollMagic.Scene({
      duration: 0,
      reverse: false,
      triggerElement: el,
      triggerHook: 0.85,
    }).setTween(tween)
      .addTo(controller);
  });

  // parallax
  if (!detectMobile()) {
    $('[data-animation="parallax"]').each((i, el) => {
      TweenMax.set(el, { y: 50 });
      const multiplier = 100;
      let top;
      new ScrollMagic.Scene({
        duration: '100%',
        triggerElement: el,
        offset: -100,
      }).on('progress', (event) => {
        top = (event.progress * multiplier) - 50;
        TweenMax.to(el, 0.65, { y: -top });
      }).addTo(controller);
    });
  }
});



// WEBPACK FOOTER //
// ./scripts/utils/scrollmagic/scenes/demo-scene_default.js